import { useEffect, useRef } from 'react'

type UseClickHandler = {
  delay: number
}

export const useClickHandler = (props: UseClickHandler) => {
  const { delay } = props

  const clickTimeout = useRef<ReturnType<typeof setTimeout> | null>(null)

  const handleClick = (event: unknown, onClick: (event: unknown) => void) => {
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current)
    }

    clickTimeout.current = setTimeout(() => onClick(event), delay)
  }

  const handleDoubleClick = (event: unknown, onClick: (event: unknown) => void) => {
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current)
    }

    onClick(event)
  }

  useEffect(() => {
    return () => {
      if (clickTimeout.current) {
        clearTimeout(clickTimeout.current)
      }
    }
  }, [])

  return { onClick: handleClick, onDoubleClick: handleDoubleClick }
}
